import { Component, OnInit } from '@angular/core';
import { EventdataService } from '../../services/eventdata.service';
import { IEvent } from '../../models/ievent';
import { Router } from '@angular/router';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-long-card',
  templateUrl: './long-card.component.html',
  styleUrls: ['./long-card.component.scss']
})
export class LongCardComponent implements OnInit {
  faAngelRight = faAngleRight;
  durhamProEventsArr: IEvent[] = [];
  skyMountainEventsArr: IEvent[] = [];
  showcasedCards: IEvent[] = [];
  nonshowcasedCards: IEvent[] = [];
  displayedEventCards: IEvent[] = [];

  constructor(public router: Router, private _eventservice: EventdataService) { }

  ngOnInit(): void {
    if (this.router.url.includes('/DurhamFerry')) {
      this.getDurhamEvents();
    }
  }
  getDurhamEvents() {
    // Clear Arrays
    this.durhamProEventsArr = [];
    this.showcasedCards = [];
    this.nonshowcasedCards = [];
    this.displayedEventCards = [];
    // Pull events from data service
    this._eventservice.getTheEvents().then((res: IEvent[]) => {
      this.durhamProEventsArr = res
        .filter(event => event.section_Adult_District === true && event.published === true && event.isDeleted === false)
        .map(event => {
          event.images = `https://stemprodstoragewest.blob.core.windows.net/photos/${event.images.split("|")[0]}`;
          event.tags = event.tags.split(',').join(' • ');
          return event
        });
      this.showcasedCards = this.durhamProEventsArr.filter(event => event.isShowcased === true);
      this.nonshowcasedCards = this.durhamProEventsArr.filter(event => event.isShowcased === false);
      console.log(this.durhamProEventsArr);
      console.log(this.showcasedCards);
      console.log(this.nonshowcasedCards);
      this.displayedEventCards = this.showcasedCards.concat(this.nonshowcasedCards);
    });
  }
  toEvent(eventCard: IEvent): void {
    // this.router.navigate(['/Event/' + eventCard.eventId]);

    if (eventCard.internal_event === true) {
      this.router.navigate(['/Event', eventCard.eventId]);
    } else if (eventCard.internal_event === false) {
      // window.location.href = eventCard.description_Long;
      window.open(eventCard.description_Long, "_blank")
    }
  }
}
